import React from 'react'

export const Context = React.createContext()
export const ContactContext = React.createContext()
export const CamDeviationContext = React.createContext()